import styled from '@emotion/styled';
import { Grid as SuiteListGrid } from '../UniversalLanding/SuiteList.style';

export const Grid = styled(SuiteListGrid)`
  max-width: 1712px;
  margin: auto;
  margin-bottom: -1px;

  @media (min-width: 1714px) {
    border-left: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
    border-right: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  }
`;

export const FeaturedDesignContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
`;
